<ng-container *ngIf="pageState$ | async as state">
    <div class="page-number no-print"><span>Page {{ index }} of {{ total }}</span></div>

    <ng-container [ngSwitch]="state?.status">

        <ng-container *ngSwitchCase="'OK'">
            <gridster
                [options]="options"
                class="report-page"
                [class.portrait]="isPortrait(state.page?.options?.config?.pageOrientation)"
                [class.landscape]="!isPortrait(state.page?.options?.config?.pageOrientation)">
                <ng-container *ngIf="state as page">
                    <ng-container *ngFor="let componentKey of state.componentKeys; index as i">
                        <pv-report-component
                            [key]="componentKey"
                            [reportKey]="state.reportKey"
                            [shareKey]="shareKey"
                            [editMode]="editMode"
                            [gridsterConfig]="options">
                        </pv-report-component>
                    </ng-container>
                </ng-container>

                <!-- Visual margin guide: edit-mode only, non-blocking, never printed -->
                <div class="page-margin-guide no-print"
                    *ngIf="editMode && (marginXPercent > 0 || marginYPercent > 0)"
                    [style.top.%]="marginYPercent"
                    [style.bottom.%]="marginYPercent"
                    [style.left.%]="marginXPercent"
                    [style.right.%]="marginXPercent">
                </div>
            </gridster>
        </ng-container>

        <!-- TODO add other switch cases -->

        <ng-container *ngSwitchCase="'LOADING'">
            <div class="report-page portrait" >
                <pv-spinner fill="white"></pv-spinner>
            </div>
        </ng-container>

    </ng-container>

</ng-container>